import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Renew functionality for User Access Review Directory
 * @param {object[]} props.staffData list of non-employees reporting to logged in user
 * @returns navigation card for renewal
 */
const RenewCard = ({ staffData = [], messages }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Non-Employee Renewal'}
			icon={<PAGE_ICONS.RENEW color='error' />}
			role={'Annual Review'}
			description={
				'Validate application access, service accounts, badges, and mobile devices for non-employees for the up to one year.'
			}
			onClick={() => history.push(PAGE_ROUTES.RENEW)}
			messages={messages}
		/>
	) : null;
};

RenewCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
	messages: PropTypes.arrayOf(PropTypes.object),
};

export default RenewCard;
